function helperGetDateFullYear (date) {
  return date.getFullYear()
}

module.exports = helperGetDateFullYear



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperGetDateFullYear.js
// module id = 170
// module chunks = 75